import { useState } from 'react'
import { Icon } from '@/shared/ui/Icon'

/**
 * Visual-only search input for this step. The query is held in local state
 * so the input is controlled, but no filtering / backend call is performed
 * yet — that hook lands when the conversations API is wired up.
 */
export function ConversationSearch() {
  const [query, setQuery] = useState('')
  return (
    <div className="search">
      <Icon name="search" className="search-icon" />
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Buscar conversa…"
        aria-label="Buscar conversa"
      />
      <kbd>⌘K</kbd>
    </div>
  )
}
